<template>
  <v-app>
    <v-container>
      <v-row class="text-center">
        <v-col>
          <h1>Welcome to Gluid!</h1>
          <!-- <v-btn icon @click="fetchAllUserSpacesForUser"
            ><v-icon>mdi-refresh</v-icon></v-btn
          > -->
        </v-col>
      </v-row>
      <v-row v-if="userSpaces" class="text-center">
        <v-col v-if="userSpaces.length !== 0">
          <h2>Your workspaces</h2>
        </v-col>
      </v-row>
      <v-row v-if="!userSpaces" class="text-center">
        <v-col>
          <h1>
            <v-progress-circular indeterminate></v-progress-circular>
          </h1>
        </v-col>
      </v-row>
      <v-row v-if="userSpaces" class="text-center">
        <v-col v-if="userSpaces.length === 0">
          <h3>You don't have any workspaces yet.</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-list v-if="userSpaces">
            <v-list-item-group v-if="userSpaces.length !== 0">
              <v-list-item
                v-for="(userSpace, j) in userSpaces"
                :key="j"
                @click="navigateToSpace(userSpace)"
                class="text-center"
              >
                <v-list-item-title
                  ><h3>{{ userSpace.title }}</h3></v-list-item-title
                >
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-list>
            <v-list-item
              @click="openNewSpaceDialog = true"
              class="justify-center"
            >
              <v-list-item-icon class="ml-8">
                <v-icon> mdi-plus </v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>

    <!--     used to create new spaces -->
    <v-dialog v-model="openNewSpaceDialog" width="800px">
      <v-card>
        <v-card-title class="grey darken-2">Add new space</v-card-title>
        <v-container>
          <h1>Space title:</h1>
          <v-text-field v-model="newSpaceTitle" />
          <p v-if="newSpaceTitleError" class="red--text">
            {{ newSpaceTitleError }}
          </p>
        </v-container>
        <v-card-actions>
          <v-btn @click="createSpace">Create Space</v-btn>
          <v-spacer />
          <v-file-input
            v-if="!isLoading"
            style="width: 200px"
            v-model="spaceFile"
            dense
            filled
            prepend-icon="mdi-code-json"
            label="File input"
            accept=".json, .xml"
            :rules="rules"
            @change="selectFile"
            full-width
          />
          <v-progress-circular indeterminate v-else />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import store from "@/store";
import router from "@/router";

import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    openNewSpaceDialog: false,
    newSpaceTitle: "New space",
    newSpaceTitleError: null,
    isLoading: false,
    spaceFile: null,
    rules: [(v) => !!v || "File is required"],
  }),
  methods: {
    ...mapActions(["fetchAllUserSpacesForUser"]),
    navigateToSpace(space) {
      router.push(`/${space.slug}`);
    },
    async createSpace() {
      this.newSpaceTitleError = null;
      try {
        const r = await store.dispatch(
          "createNewSpaceAndDocumentForUser",
          this.newSpaceTitle
        );
        await router.push(`/${r.data.tree.slug}`);
      } catch (err) {
        this.newSpaceTitleError = err;
      }
    },
    async selectFile() {
      this.newSpaceTitleError = null;
      if (!this.spaceFile) return;

      const reader = new FileReader();
      reader.onload = async (e) => {
        this.isLoading = true;

        try {
          const tree = JSON.parse(e.target.result);
          const r = await store.dispatch("createSpaceFromFile", {
            // title: tree.title,
            title: tree.properties.title,
            json: tree,
            gluidId: router.currentRoute.params.gluidId,
          });
          console.log(r);
          await router.push(`/${r.slug}`);
        } catch (err) {
          console.log("There is an error in frontend");
          console.error(err);
          this.newSpaceTitleError = "ERROR: " + err.message;
          this.isLoading = false;
        }
      };
      this.isLoading = false;

      reader.readAsText(this.spaceFile);
    },
  },
  computed: {
    ...mapGetters(["userSpaces"]),
  },
};
</script>
